import type { ApiResponse } from '../types';
import { getErrorMessage } from '../types';
import { authApi, API_BASE } from './auth';

export { API_BASE };

export function getAuthHeaders(contentType?: string): HeadersInit {
  const token = authApi.getToken();
  if (!token) throw new Error('Not authenticated');
  const headers: Record<string, string> = { 'Authorization': `Bearer ${token}` };
  if (contentType) headers['Content-Type'] = contentType;
  return headers;
}

export async function handleApiResponse<T>(response: Response): Promise<T> {
  if (response.status === 401) {
    authApi.logout();
    window.dispatchEvent(new CustomEvent('session-expired'));
    throw new Error('Session expired');
  }

  const text = await response.text();
  if (!text) {
    throw new Error(`API error: ${response.status} (empty response)`);
  }

  let data: ApiResponse<T>;
  try {
    data = JSON.parse(text);
  } catch {
    throw new Error(`API error: ${response.status} (invalid JSON)`);
  }

  if (!response.ok || !data.success) {
    throw new Error(getErrorMessage(data.error) || `API error: ${response.status}`);
  }

  return data.data as T;
}

export async function fetchWithAdmin<T>(endpoint: string, options?: RequestInit): Promise<T> {
  const response = await fetch(`${API_BASE}${endpoint}`, {
    ...options,
    headers: {
      ...getAuthHeaders('application/json'),
      ...options?.headers,
    },
  });
  return handleApiResponse<T>(response);
}
